export const technologies = [
  { id: 1, name: "Python" },
  { id: 2, name: "TypeScript, JavaScript" },
  { id: 3, name: "Django & Django REST Framework" },
  { id: 4, name: "Node.js, Express" },
  { id: 5, name: "React, Next.js" },
  { id: 6, name: "PostgreSQL, Prisma ORM" },
  { id: 7, name: "Docker" },
  { id: 8, name: "Git, GitHub Actions" },
  { id: 9, name: "Google Cloud Platform (GCP)" },
  { id: 10, name: "Postman" },
  { id: 11, name: "Jest, Vitest" },
];
